import { TGlobalStore } from 'store'
import type { StoreApi } from 'zustand'
import { clearScanAlertDismissed } from 'util/sessionStorage'

export interface IScanState {
  scanInProgress: boolean
  scanHasError: boolean
  shouldFetchScan: boolean
  setScanInProgress: (value: boolean) => void
  setScanHasError: (value: boolean) => void
  setShouldFetchScan: (value: boolean) => void
  resetScanState: () => void
}

const scanSlice = (set: StoreApi<TGlobalStore>['setState']): IScanState => ({
  scanInProgress: false,
  scanHasError: false,
  shouldFetchScan: true,
  setScanInProgress: value => set(state => ({ ...state, scanInProgress: value })),
  setScanHasError: value => set(state => ({ ...state, scanHasError: value })),
  setShouldFetchScan: value => set(state => ({ ...state, shouldFetchScan: value })),
  resetScanState: () => {
    clearScanAlertDismissed()
    set(state => ({
      ...state,
      scanInProgress: true,
      scanHasError: false,
      shouldFetchScan: true,
    }))
  },
})

export default scanSlice
